<template>
  <v-row>
    <v-col class="col-5 col-md-5 col-sm-12 bold-900">
      {{ $t('repairs.detail.km').toUpperCase() }}
    </v-col>
    <v-col class="col-7 col-md-7 col-sm-12">
      <v-row no-gutters>
        <v-col cols="6" class="col-md-6 col-sm-12">
          <v-row no-gutters>
            <v-col class="col-12 subtitle">
              <small>{{ $t('repairs.detail.km-message').toUpperCase() }}</small>
            </v-col>
            <v-col class="col-12">
              <text-field
                :value="km"
                :rules="`min_value:${minKm}`"
                name="km"
                type="number"
                :placeholder="$t('repairs.detail.motorbike-km')"
                :min="minKm"
                step="1"
                @input="handleInputKm" />
            </v-col>
          </v-row>
        </v-col>
        <v-col class="col-md-6 col-sm-12">
          <v-row no-gutters>
            <v-col class="col-12 subtitle">
              <small>{{ $t('repairs.detail.repair-date').toUpperCase() }}</small>
            </v-col>
            <v-col class="col-12">
              <date-picker
                :initValue="now"
                :clearable="false"
                :not-before="lastInspectionDate"
                :not-after="now"
                v-model="currentRevision.day" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment'

import DatePicker from '@/components/general/DatePicker'
import TextField from '@/components/general/TextField'

export default {
  inject: ['$validator'],
  components: {
    DatePicker,
    TextField,
  },
  data() {
    return {
      minKm: Math.round(this.currentRevision.km * 0.9),
      km: null,
    }
  },
  computed: {
    now() {
      return new Date()
    },
    lastInspectionDate() {
      const formattedDate = moment(this.inspection.createdDate, 'DD/MM/YYYY').format('MM/DD/YYYY')
      return new Date(formattedDate)
    },
  },
  methods: {
    handleInputKm(value) {
      this.km = value
      const intValue = parseInt(value.replace(/[.,]/g, ''))

      if (isNaN(intValue)) {
        this.currentRevision.km = this.minKm
        return
      }

      if (intValue >= this.minKm) {
        this.currentRevision.km = intValue
        return
      }

      this.currentRevision.km = this.minKm
    },
  },
  props: ['currentRevision', 'inspection'],
}
</script>
<style scoped>
.redbg {
  color: red !important;
}
.subtitle {
  font-family: 'ProximaNovaExCnLight', 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  font-size: 14px;
  color: #888;
}
</style>
